export default function(){
    jQuery('.promocode-wrapper').each(function(){
        let $e      = jQuery(this);

        let $input  = $e.find('.promocode-input');
        let $promo  = $e.find('.promocode-btn');
        let $notices= $e.find('.promocode-notices');

        let $csrf   = $e.find('input[name="_promocode_csrf"]');

        let $remove = $e.find('.promocode-remove');

        let applyPromocode = function(){
            let code = $input.val();
            if (code === undefined || code == '') return;

            $notices.text('');
            $notices.removeClass('has-notices');

            jQuery.ajax({
                method: 'POST',
                dataType: 'json',
                url: '/applyPromocode',
                data: {
                    code: code,
                    '_token': $csrf.val()
                }
            }).done(function(res){
                $notices.toggleClass('has-notices', res.notices.length > 0);
                
                for(let i in res.notices){
                    $notices.append('<p>' + res.notices[i] + '</p>');
                }

                if( res.success ) window.location.reload();
            });
        };

        if($input.length > 0 && $promo.length > 0){
            $input.on('keydown', function(e){
                let key = e.key || e.keyCode;
                if (key == 'Enter' || key == 13){
                    e.preventDefault();
                    applyPromocode();
                    return false;
                }
            });

            $promo.on('click', function(){
                applyPromocode();
            });
        }

        if($remove.length > 0){
            $remove.on('click', function(){
                jQuery.ajax({
                    method: 'GET',
                    url: '/removePromocode'
                }).done(function(res){
                    window.location.reload();
                });
            });
        }
    });
}